import React from 'react';
import {useSelector, useDispatch, RootStateOrAny} from "react-redux"
import { IFooterTab, Tabs } from '../Tabs';
import { SUB_TABS_IMAGE, TABS, tabType } from '../constants';

import {
    clearLeftWorkAreaState,
    clearActiveObject,
    clearActiveObjects,
  } from "../../../redux/actions/product2dActions"
import { IMAGE_SETTINGS, SETTINGS_TITLE } from './constants';
import { SettingSlider } from '../Sliders';
import { Settings } from './Settings';

interface IImageSubFooter {
    tabSelection: (tab: tabType) => void
}

export const ImageSubFooter = (props: IImageSubFooter) => {
    const { tabSelection } = props;

    const makFabric = useSelector((state: RootStateOrAny) => state.makFabric)
    const activeObj = useSelector((state: RootStateOrAny) => state.activeObj)
    const activeObjs = useSelector((state: RootStateOrAny) => state.activeObjs)
    const dispatch = useDispatch()

    const tabs: IFooterTab[] = [
        {
            imageSrc: "./assets/img/icons/trash_icn.svg",
            title: SUB_TABS_IMAGE.DELETE.title,
            onClick:()=>{
                makFabric.removeObjects()
                dispatch(clearLeftWorkAreaState())
                dispatch(clearActiveObject())
                dispatch(clearActiveObjects())
            },
            disable: activeObjs.length > 1 || activeObj && activeObj.type === "rect"
        },
        {
            imageSrc: "./assets/img/icons/copy_icn.svg",
            title: SUB_TABS_IMAGE.DUPLICATE.title,
            onClick:()=>{makFabric.copyObject(activeObj)},
            disable: activeObjs.length > 1 || activeObj && activeObj.type === "rect"
        },
        {
            imageSrc: "./assets/img/icons/flip_v.svg",
            title: SUB_TABS_IMAGE.FLIP_V.title,
            onClick:()=>{makFabric.flipYObjects()},
            disable: activeObjs.length > 1 || activeObj && activeObj.type === "rect"
        },
        {
            imageSrc: "./assets/img/icons/flip_h.svg",
            title: SUB_TABS_IMAGE.FLIP_H.title,
            onClick:()=>{makFabric.flipXObjects()},
            disable: activeObjs.length > 1 || activeObj && activeObj.type === "rect"
        },
        {
            imageSrc: "./assets/img/icons/align_l.svg",
            title: SUB_TABS_IMAGE.ALIGN_LEFT.title,
            onClick:()=>{makFabric.alignObjects("LEFT")},
            disable: activeObjs.length > 1 || activeObj && activeObj.type === "rect"
        },
        {
            imageSrc: "./assets/img/icons/align_r.svg",
            title: SUB_TABS_IMAGE.ALIGN_RIGHT.title,
            onClick:()=>{makFabric.alignObjects("RIGHT")},
            disable: activeObjs.length > 1 || activeObj && activeObj.type === "rect"
        },
        {
            imageSrc: "./assets/img/icons/align_c.svg",
            title: SUB_TABS_IMAGE.ALIGN_CENTER.title,
            onClick:()=>{makFabric.alignObjects("CENTER")},
            disable: activeObjs.length > 1 || activeObj && activeObj.type === "rect"
        },
        {
            imageSrc: "./assets/img/icons/align_t.svg",
            title: SUB_TABS_IMAGE.ALIGN_TOP.title,
            onClick:()=>{makFabric.alignObjects("TOP")},
            disable: activeObjs.length > 1 || activeObj && activeObj.type === "rect"
        },
        {
            imageSrc: "./assets/img/icons/align_b.svg",
            title: SUB_TABS_IMAGE.ALIGN_BOTTOM.title,
            onClick:()=>{makFabric.alignObjects("BOTTOM")},
            disable: activeObjs.length > 1 || activeObj && activeObj.type === "rect"
        },
        {
            imageSrc: "./assets/img/icons/bring_front_icn.svg",
            title: SUB_TABS_IMAGE.BRING_FRONT.title,
            onClick:()=>{makFabric.bringToFrontObjs()},
            disable: activeObjs.length > 1 || activeObj && activeObj.type === "rect"
        },
        {
            imageSrc: "./assets/img/icons/send_back_icn.svg",
            title: SUB_TABS_IMAGE.SEND_BACK.title,
            onClick:()=>{makFabric.sendToBackObjs()},
            disable: activeObjs.length > 1 || activeObj && activeObj.type === "rect"
        }
    ]



    return <Tabs mainTabItems={tabs} settingsTitle={SETTINGS_TITLE}>
       <Settings/>
    </Tabs>
}